<template>
  <div class="fts-automation-label">
    <i class="automation-label__icon" :class="getIcon" v-if="getIcon"></i>
    <fts-tippy 
      trigger-class="automation-label-name fts-cursor-default"
      :content="labelName"
      class="automation-label__name"
      v-if="tooltip">
      <template #trigger>{{labelName}}</template>
    </fts-tippy>
    <div class="automation-label__name" v-else>
      <div class="automation-label-name">{{labelName}}</div>
    </div>
  </div>
</template>

<script>
import commons from '../../commons/commons';
import FTSTippy from "../../elements/FTSTippy";

export default {
  props: {
    labelName: [String, Number],
    labelType: Number,
    tooltip: Boolean,
  },
  components: {
    "fts-tippy": FTSTippy,
  },
  computed: {
    getIcon() {
      return this.labelType && commons.informationIcon(this.labelType);
    },
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-automation-label {
  min-width: 0;
  display: flex;
  align-items: center;
  .automation-label__icon {
    margin-right: .375rem;
    color: $grayLightColor;
  }
  .automation-label__name {
    min-width: 0;
    .automation-label-name {
      @include text-overflow-ellipsis;
    }
  }
}
</style>